import Circle from './Circle';
import HeroText from './HeroText';
import Parallax from './Parallax';

const Hero = () => {
  return (
    <div id="hero-whole">
      <HeroText />
      <Circle />
      <Parallax />
    </div>
  );
};

export default Hero;
